import React, { useState } from 'react';

import { utils } from 'utils';

import { LoginPageShell } from '../layout';
import ForgotPasswordForm from '../components/ForgotPasswordForm';
import ResetSentConfirmation from '../components/ResetSentConfirmation';

const ForgotPasswordPage = () => {
  const [isResetSent, setIsResetSent] = useState(false);

  utils.useDocumentTitle('Forgot Password');
  utils.usePageView('forgot');

  const handleResetSent = () => setIsResetSent(true);

  return (
    <LoginPageShell>
      {isResetSent
        ? <ResetSentConfirmation />
        : <ForgotPasswordForm onResetSent={handleResetSent} />
      }
    </LoginPageShell>
  );
};

export default ForgotPasswordPage;
